import React from "react";

const ProductDescription = ({ details }) => {
  // Check if details exist to avoid rendering errors
  if (!details) {
    return null; // If no details, render nothing
  }

  // Function to calculate totals for tableData
  const calculateTotals = (data) => {
    if (!data || data.length === 0) return { totalPcs: 0, totalDiamondWeight: 0 }; // Handle empty or undefined data
    const totalPcs = data.reduce((sum, row) => sum + (row.pcs || 0), 0);
    const totalDiamondWeight = data.reduce((sum, row) => sum + (row.tdWt || 0), 0);
    return { totalPcs, totalDiamondWeight };
  };

  // Function to calculate totals for diamondDetails
  const calculateDiamondTotals = (data) => {
    if (!data || data.length === 0)
      return { totalDiamonds: 0, totalDiamondWeight: 0 }; // Handle empty or undefined data
    const totalDiamonds = data.reduce((sum, diamond) => sum + (diamond.numberOfDiamonds || 0), 0);
    const totalDiamondWeight = data.reduce((sum, diamond) => sum + (diamond.totalWeight || 0), 0);
    return { totalDiamonds, totalDiamondWeight };
  };

  // Safely calculate totals
  const tableTotals = calculateTotals(details?.tableData || []);
  const diamondTotals = calculateDiamondTotals(details?.details?.diamondDetails || []);

  return (
    <div className="mt-8 bg-white p-6 shadow-md rounded-lg">
      {/* Title */}
      <h2 className="text-2xl font-bold mb-4 text-gray-800">Product Description</h2>

      {/* Product Details */}
      <h3 className="text-lg font-semibold mb-4 text-gray-700">Product Details:</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <p className="text-sm">
          <span className="font-semibold">Stamp / Hallmark:</span> {details.hallmark || "YES"}
        </p>
        <p className="text-sm">
          <span className="font-semibold">Certificate:</span> {details.certificate || "YES"}
        </p>
        <p className="text-sm text-center text-red-500">
          <span className="font-semibold">All Details and Certificates Provided Based on  Your Requirements.</span> 
        </p>
      </div>

      {/* Diamond Details */}
      {details?.details?.diamondDetails && details.details.diamondDetails.length > 0 && (
        <>
          <h3 className="text-lg font-semibold mt-8 text-gray-700">Diamond Details: (Natural)</h3>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border mt-4 text-sm">
              <thead>
                <tr className="bg-gray-100 text-gray-700">
                  <th className="border px-4 py-2 text-left">Shape</th>
                  <th className="border px-4 py-2 text-left">Color</th>
                  <th className="border px-4 py-2 text-left">Clarity</th>
                  <th className="border px-4 py-2 text-left">Size</th>
                  <th className="border px-4 py-2 text-left">No. of Diamonds</th>
                  <th className="border px-4 py-2 text-left">Total Weight (Ct)</th>
                </tr>
              </thead>
              <tbody>
                {details.details.diamondDetails.map((diamond, index) => (
                  <tr key={index} className="text-gray-600">
                    <td className="border px-4 py-2">{diamond.shape || "N/A"}</td>
                    <td className="border px-4 py-2">{diamond.color || "N/A"}</td>
                    <td className="border px-4 py-2">{diamond.clarity || "N/A"}</td>
                    <td className="border px-4 py-2">{diamond.size || "N/A"}</td>
                    <td className="border px-4 py-2">{diamond.numberOfDiamonds || 0}</td>
                    <td className="border px-4 py-2">{diamond.totalDiamondWeight || 0}</td>
                  </tr>
                ))}
                {/* <tr className="font-bold text-gray-700">
                  <td className="border px-4 py-2">Total</td>
                  <td className="border px-4 py-2"></td>
                  <td className="border px-4 py-2"></td>
                  <td className="border px-4 py-2"></td>
                  <td className="border px-4 py-2">{diamondTotals.totalDiamonds}</td>
                  <td className="border px-4 py-2">{diamondTotals.totalDiamondWeight}</td>
                </tr> */}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* Table Data */}
      {/* {details?.tableData && details.tableData.length > 0 && (
        <>
          <h3 className="text-lg font-semibold mt-8 text-gray-700">Table Data</h3>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border mt-4 text-sm">
              <thead>
                <tr className="bg-gray-100 text-gray-700">
                  <th className="border px-4 py-2 text-left">Sieve Size</th>
                  <th className="border px-4 py-2 text-left">D WT</th>
                  <th className="border px-4 py-2 text-left">D MM</th>
                  <th className="border px-4 py-2 text-left">PCS</th>
                  <th className="border px-4 py-2 text-left">T D WT</th>
                </tr>
              </thead>
              <tbody>
                {details.tableData.map((row, index) => (
                  <tr key={index} className="text-gray-600">
                    <td className="border px-4 py-2">{row.sieveSize || "N/A"}</td>
                    <td className="border px-4 py-2">{row.dWt || "N/A"}</td>
                    <td className="border px-4 py-2">{row.dMm || "N/A"}</td>
                    <td className="border px-4 py-2">{row.pcs || 0}</td>
                    <td className="border px-4 py-2">{row.tdWt || 0}</td>
                  </tr>
                ))}
                <tr className="font-bold text-gray-700">
                  <td className="border px-4 py-2">Total</td>
                  <td className="border px-4 py-2"></td>
                  <td className="border px-4 py-2"></td>
                  <td className="border px-4 py-2">{tableTotals.totalPcs}</td>
                  <td className="border px-4 py-2">{tableTotals.totalDiamondWeight}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      )} */}
    </div>
  );
};

export default ProductDescription;
